import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.897 0A5.02 5.02 0 0 0 2 5.122a4.77 4.77 0 0 0 .77 2.588l3.694 6.04a.504.504 0 0 0 .866 0l3.693-6.04c.5-.77.768-1.669.77-2.588A5.02 5.02 0 0 0 6.898 0m0 1.024a3.99 3.99 0 0 1 3.884 4.098 3.6 3.6 0 0 1-.623 2.048l-3.261 5.336-3.26-5.338a3.6 3.6 0 0 1-.624-2.048 3.99 3.99 0 0 1 3.884-4.091zm0 1.365a2.56 2.56 0 1 0-.055 5.12 2.56 2.56 0 0 0 .055-5.119m0 1.024a1.537 1.537 0 1 1-1.52 1.537 1.52 1.52 0 0 1 1.52-1.536" }, null, -1)
  ])))
}
export default { render: render }